import { Alert, Button, Stack, Typography } from "@mui/material"
import { Link, useParams } from "react-router-dom"
import { PostBotNavigation } from "../components/common/postBotNavigation"
import { OccurrenceHistoryTable } from "../components/occurrences/occurrenceHistoryTable"
import { placementPath } from "../utils/placementDraft"

export default function PlacementHistoryPage({
  placementId,
  canRead = true,
}: {
  placementId?: string
  canRead?: boolean
}) {
  const params = useParams()
  const id = placementId ?? params.placementId ?? params.id ?? ""
  const valid = /^[1-9][0-9]*$/.test(id) && BigInt(id) <= 2147483647n
  return (
    <Stack spacing={2} sx={{ width: "100%", minWidth: 0 }}>
      <PostBotNavigation />
      <Typography variant="h4">История размещения {id}</Typography>
      {!canRead ? (
        <Alert severity="warning">Нет доступа к чтению истории</Alert>
      ) : !valid ? (
        <Alert severity="error">Некорректный ID размещения</Alert>
      ) : (
        <>
          <Button component={Link} to={placementPath(id)}>
            К размещению
          </Button>
          <OccurrenceHistoryTable key={id} placementId={id} />
        </>
      )}
    </Stack>
  )
}
